import * as Sentry from '@sentry/vue'

export const captureUnexpectedError = error => {
  if (!error.response || error.response.status >= 500) {
    Sentry.captureException(error)
  }
}
